import React from 'react';
import { useSelector } from 'react-redux';

import Modal from 'common/Modal/Modal';
import TermsAndConditions from '../TermsAndConditions/TermsAndConditions';

const TermsAndConditionsModal = ({ closeModal }) => {
	const modalData = useSelector((state)=>state.mice.modalData);
	return (
		<Modal
			Modaldata={{
				customWrapperClass: 'mice'
			}}
			type='bottom'
			close
			handleModal={closeModal}
			isResponsive>
			<TermsAndConditions data={modalData} isPopUp />
		</Modal>
	);
};

export default TermsAndConditionsModal;
